import LegalDocument from './LegalDocument';
import PageHero from '../ui/PageHero/PageHero';
import Section from '../ui/Section/Section';
import type { LegalDocumentContent } from '../../locales/types';
import styles from './LegalPage.module.css';

interface LegalPageProps {
    content: LegalDocumentContent;
    contentLanguage: string;
}

export default function LegalPage({ content, contentLanguage }: LegalPageProps) {
    return (
        <div lang={contentLanguage}>
            <PageHero title={content.title} lead={content.subtitle}>
                {content.lastUpdated && <p className={styles.meta}>{content.lastUpdated}</p>}
            </PageHero>
            <Section theme="light" shape="sheet">
                <div className={`page-inner ${styles.content}`}>
                    <LegalDocument sections={content.sections} />
                </div>
            </Section>
        </div>
    );
}
